import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import MobileMenu from "./MobileMenu";
import productData from "../data/products.json";

function HeaderOne() {
  const navigate = useNavigate();

  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  // NEW STATES FOR SEARCH + MINI CART
  const [showSearch, setShowSearch] = useState(false);
  const [showMiniCart, setShowMiniCart] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const [cartItems, setCartItems] = useState([]);

  // Detect login + cart status
  useEffect(() => {
    const updateCart = () => {
      const cart = JSON.parse(sessionStorage.getItem("cart")) || [];
      setCartItems(cart);
      setCartCount(cart.reduce((sum, item) => sum + item.quantity, 0));
    };

    // Run once immediately
    updateCart();

    // Listen for custom event
    window.addEventListener("cart-updated", updateCart);

    return () => window.removeEventListener("cart-updated", updateCart);
  }, []);

  // Sticky logic
  useEffect(() => {
    const scrollHandler = () => setIsSticky(window.scrollY > 500);
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  // Logout
  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("cart");
    sessionStorage.removeItem("orderHistory");
    navigate("/login-now");
  };

  // -------- SEARCH DEBOUNCE --------
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!searchText.trim()) {
        setSearchResults([]);
        return;
      }
      const results = productData.filter((p) =>
        p.name.toLowerCase().includes(searchText.toLowerCase())
      );
      setSearchResults(results);
    }, 400);

    return () => clearTimeout(timer);
  }, [searchText]);

  // -------- MINI CART REMOVE --------
  const removeItem = (id) => {
    const updated = cartItems.filter((i) => i.id !== id);
    sessionStorage.setItem("cart", JSON.stringify(updated));
    setCartItems(updated);
    setCartCount(updated.reduce((sum, item) => sum + item.quantity, 0));

    // 🔥 Refresh header count instantly
    window.dispatchEvent(new Event("cart-updated"));
  };

  const cartTotal = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <>
      {/* ================= HEADER ================= */}
      <header className="th-header header-layout1">
        <div className="header-top">
          <div className="container th-container">
            <div className="row justify-content-center justify-content-xl-between align-items-center">
              <div className="col-auto d-none d-md-block">
                <div className="header-links">
                  <ul>
                    <li className="d-none d-xl-inline-block">
                      <i className="fa-sharp fa-regular  fa-location-dot" />
                      <span>5707 E. 32nd Street Lot 714, Yuma, AZ 85365</span>
                    </li>
                    <li className="d-none d-xl-inline-block">
                      <i className="fa-regular fa-clock" />
                      <span>Mon to Fri: 9:00 am - 5:00 pm</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-auto">
                <div className="header-right">
                  <div className="header-links">
                    <ul>
                      <li className="d-none d-xl-inline-block">
                        <i className="fa-sharp fa-regular fa-envelope" />
                        <span>info@printersfriendly.com</span>
                      </li>
                      <li className="d-none d-xl-inline-block">
                        <i className="fa-sharp fa-regular fa-phone" />
                        <span>+1-425-330-4080</span>
                      </li>

                      {isLoggedIn ? (
                        <>
                          <li>
                            <Link to="/my-account">My Account</Link>
                          </li>
                          <li>
                            <button
                              className="logout-btn"
                              onClick={handleLogout}
                            >
                              Logout
                            </button>
                          </li>
                        </>
                      ) : (
                        <li>
                          <Link to="/login-now">Login</Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sticky Navigation */}
        <div className={`sticky-wrapper ${isSticky ? "sticky" : ""}`}>
          <div className="menu-area">
            <div className="container th-container">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <div className="header-logo">
                    <Link to="/">
                      <img src="/assets/img/logo.svg" alt="logo" />
                    </Link>
                  </div>
                </div>

                <div className="col-auto me-xl-auto">
                  <nav className="main-menu d-none d-xl-inline-block">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>
                      <li>
                        <Link to="/shop">Our Printers</Link>
                      </li>
                      <li>
                        <Link to="/our-accessories">Our Accessories</Link>
                      </li>
                      <li>
                        <Link to="/office-printers">Office Printers</Link>
                      </li>
                      <li>
                        <Link to="/home-printers">Home Printers</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact us</Link>
                      </li>

                      {/* ---- NEW BUTTONS ---- */}
                      <li>
                        <button
                          className="cart-icon"
                          onClick={() => setShowMiniCart(true)}
                        >
                          <i className="fa-solid fa-cart-shopping"></i> ( Cart{" "}
                          {cartCount})
                        </button>
                      </li>

                      <li>
                        <button
                          className="search-btn"
                          onClick={() => setShowSearch(true)}
                        >
                          <i className="fa-solid fa-magnifying-glass"></i>{" "}
                          Search Products
                        </button>
                      </li>
                    </ul>
                  </nav>

                  <button
                    type="button"
                    className="th-menu-toggle d-block d-xl-none"
                    onClick={() => setIsMobileMenuOpen(true)}
                  >
                    <i className="far fa-bars" />
                  </button>
                </div>
              </div>
            </div>

            <div
              className="logo-bg bg-mask"
              style={{
                WebkitMaskImage: "url(/assets/img/logo_bg_mask.png)",
                maskImage: "url(/assets/img/logo_bg_mask.png)",
              }}
            />
          </div>
        </div>
      </header>

      {/* ================= SEARCH POPUP ================= */}
      {showSearch && (
        <div className="search-overlay" onClick={() => setShowSearch(false)}>
          <div className="search-modal" onClick={(e) => e.stopPropagation()}>
            <input
              autoFocus
              type="text"
              className="search-input"
              placeholder="Search printers..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />

            {searchResults.length > 0 ? (
              <div className="search-results">
                {searchResults.map((item) => (
                  <div
                    key={item.id}
                    className="search-item"
                    onClick={() => navigate(`/product-details/${item.id}`)}
                  >
                    <img
                      src={
                        Array.isArray(item.imageUrl)
                          ? item.imageUrl[0]
                          : item.imageUrl
                      }
                      alt=""
                    />
                    <div>
                      <h6>{item.name}</h6>
                      <p>${item.price}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              searchText && <p className="no-results">No matching products</p>
            )}
          </div>
        </div>
      )}

      {/* ================= MINI CART SLIDER ================= */}
      {showMiniCart && (
        <div
          className="mini-cart-overlay"
          onClick={() => setShowMiniCart(false)}
        >
          <div className="mini-cart" onClick={(e) => e.stopPropagation()}>
            <h4>Your Cart</h4>

            {cartItems.length === 0 ? (
              <p className="empty-cart">Your cart is empty</p>
            ) : (
              <>
                {cartItems.map((item) => (
                  <div key={item.id} className="cart-row">
                    <img
                      src={
                        Array.isArray(item.imageUrl)
                          ? item.imageUrl[0]
                          : item.imageUrl
                      }
                      alt=""
                    />

                    <div>
                      <p>{item.name}</p>
                      <small>
                        Qty: {item.quantity} × ${item.price}
                      </small>
                    </div>

                    <button onClick={() => removeItem(item.id)}>✖</button>
                  </div>
                ))}

                <div className="cart-total">
                  Total: <strong>${cartTotal.toFixed(2)}</strong>
                </div>

                <button onClick={() => navigate("/cart")} className="mini-btn">
                  View Cart
                </button>
                <button
                  onClick={() => navigate("/checkout")}
                  className="mini-btn checkout"
                >
                  Checkout
                </button>
              </>
            )}
          </div>
        </div>
      )}

      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />

      {/* Styles - only added for search + minicart */}
      <style>{`
        .cart-icon, .search-btn {
          background:none;
          border:none;
          cursor:pointer;
          font-size:17px;
        }

        /* SEARCH */
        .search-overlay {
          position:fixed; inset:0; background:rgba(0,0,0,0.6);
          display:flex; justify-content:center; align-items:center; z-index:9999;
        }
        .search-modal {
          background:#fff; padding:25px; width:450px; border-radius:12px;
          box-shadow:0 6px 20px rgba(0,0,0,0.15);
        }
        .search-input {
          width:100%; padding:14px; border-radius:10px; border:1px solid #ccc; margin-bottom:15px;
        }
        .search-results{ max-height:250px; overflow-y:auto; }
        .search-item {
          display:flex; gap:10px; padding:10px; border-bottom:1px solid #eee; cursor:pointer;
        }
        .search-item img { width:55px; height:55px; border-radius:8px; }
        .no-results{ text-align:center; margin-top:10px; color:#666; }

        /* MINI CART */
        .mini-cart-overlay {
          position:fixed; inset:0; background:rgba(0,0,0,0.4);
          display:flex; justify-content:flex-end; z-index:9999;
        }
        .mini-cart {
          width:350px; background:#fff; height:100vh; padding:20px;
          box-shadow:-6px 0 15px rgba(0,0,0,0.15);
        }
        .cart-row { display:flex; gap:10px; margin-bottom:12px; align-items:center; }
        .cart-row img { width:60px; border-radius:8px; }
        .empty-cart { text-align:center; margin-top:30px; }
        .cart-total { margin-top:15px; font-size:18px; font-weight:bold; }
        .mini-btn {
          width:100%; margin-top:10px; padding:12px;
          background:#0b61d6; color:#fff; border:none; border-radius:10px; cursor:pointer;
        }
        .mini-btn.checkout{ background:#27ae60; }
      `}</style>
    </>
  );
}

export default HeaderOne;
